module.exports = __webpack_public_path__ + "883ac8583bca6aa4a72df698fb800b5d.svg";